import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { getPublicPersona } from '../services/apiService';
import ChatPage from './ChatPage';
import PersonaImage from '../components/molecules/PersonaImage';
import styles from './PublicPersonaPage.module.css';

const PublicPersonaPage = () => {
  const { username } = useParams();
  const [personaData, setPersonaData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPersona = async () => {
      try {
        setIsLoading(true);
        const data = await getPublicPersona(username);
        setPersonaData(data);
      } catch (e) {
        setError('Persona not found or is not public.');
        console.error(e);
      } finally {
        setIsLoading(false);
      }
    };

    fetchPersona();
  }, [username]);

  if (isLoading) {
    return <div className={styles.centeredStatus}>Loading Persona...</div>;
  }

  if (error) {
    return <div className={styles.centeredStatus}>{error}</div>;
  }

  // --- Determine which badges to show ---
  const isVerified = personaData.verificationStatus?.hasCompletedFullTest;
  const isPro =
    personaData.planTier === 'pro' ||
    personaData.planTier === 'founder' ||
    personaData.planTier === 'vip';

  return (
    <div className={styles.pageWrapper}>
      <header className={styles.publicHeader}>
        <PersonaImage
          personaId={personaData.personaId}
          alt={personaData.publicName || personaData.personaName}
          className={styles.headerAvatar}
          isOwner={false}
          username={personaData.username}
        />
        <div className={styles.headerInfo}>
          <h1 className={styles.personaName}>
            {personaData.publicName || personaData.personaName}
          </h1>
          <p className={styles.personaSummary}>{personaData.summary}</p>

          <div className={styles.verificationSection}>
            <div className={`${styles.badge} ${styles.social}`}>
              ✅ Socially Verified
            </div>
            {isVerified && (
              <div className={`${styles.badge} ${styles.gold}`}>
                🥇 Psychometrically Verified
              </div>
            )}
            {isPro && (
              <div className={`${styles.badge} ${styles.pro}`}>
                👑 Pro Member
              </div>
            )}
          </div>
        </div>
        <div className={styles.headerBranding}>
          <p>
            Powered by{' '}
            <Link to="/" className={styles.brandLink}>
              Ego Protocol
            </Link>
          </p>
        </div>
      </header>

      <main className={styles.chatContainer}>
        {personaData && (
          <ChatPage mode="public" publicPersonaData={personaData} />
        )}
      </main>
    </div>
  );
};

export default PublicPersonaPage;
